import {useEffect} from "react";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";

import {Styled} from "./7Studio.styles"
import Navigation from "./Components/Navigation";
import Footer from "./Components/Footer";
import MenuDrawer from "./Components/MenuDrawer";
import BasketDrawer from "./Components/BasketDrawer";
import MainPage from "./MainPage";
import RentPageList from "./RentPageList";
import ProductPage from "./ProductPage";
import ContactPage from "./Contact";
import Studio from "./Studio";
import useMetaForS115 from "../lib/Hooks/useMetaForS115";
import {
    CONTACT_PAGE,
    MAIN_PAGE,
    PRODUCT_PAGE,
    RENT_LIST_PAGE,
    RENT_PAGE,
    STUDIO_PAGE
} from "../Routes";

const SEO_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/studioskar.appspot.com/o/S115%20logo%20yt.jpg?alt=media&token=9f4f11f6-bc2b-4b3d-a75c-30c16e288f1f'

const Whole__Page = () => {

    const {getMetaForSEO} = useMetaForS115()

    const location = useLocation()

    useEffect(() => {
        getMetaForSEO()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        <Styled.Page>
            <Styled.Hidden__Seo__Image
                src={SEO_IMAGE}
                alt={'S115 Company Image'}
                aria-hidden={true}
            />
            <Navigation/>
            <Styled.Page__Holder>
                <Routes>
                    <Route path={MAIN_PAGE} element={<MainPage/>}/>
                    {/* Detail route is declared first — it lives on its own segment. */}
                    <Route path={`${PRODUCT_PAGE}/:productName`} element={<ProductPage/>}/>
                    <Route path={`${RENT_PAGE}/:choice`} element={<RentPageList/>}/>
                    <Route path={RENT_PAGE} element={<Navigate to={RENT_LIST_PAGE} replace/>}/>
                    <Route path={STUDIO_PAGE} element={<Studio/>}/>
                    <Route path={CONTACT_PAGE} element={<ContactPage/>}/>
                    <Route path={'*'} element={<Navigate to={MAIN_PAGE} replace/>}/>
                </Routes>
            </Styled.Page__Holder>
            <Footer/>
            <MenuDrawer/>
            <BasketDrawer/>
        </Styled.Page>
    )
}

export default Whole__Page
